export default {
  sentenceFetching1: {
    id: 'shopping_assistant_loading_message_fetching_1',
    defaultMessage: 'Consulting my crystal ball (it’s refurbished)',
  },
  sentenceFetching2: {
    id: 'shopping_assistant_loading_message_fetching_2',
    defaultMessage: 'Doing the math so you don’t have to',
  },
  sentenceFetching3: {
    id: 'shopping_assistant_loading_message_fetching_3',
    defaultMessage: 'Putting on my thinking RAM',
  },
  sentenceFetching4: {
    id: 'shopping_assistant_loading_message_fetching_4',
    defaultMessage: 'Playing 4D chess with the inventory',
  },
  sentenceFetching5: {
    id: 'shopping_assistant_loading_message_fetching_5',
    defaultMessage: 'Mining for gold in the catalog',
  },
  sentenceFetching6: {
    id: 'shopping_assistant_loading_message_fetching_6',
    defaultMessage: 'Solving for X (X = exactly what you’re looking for)',
  },
  sentenceRefining1: {
    id: 'shopping_assistant_loading_message_refining_1',
    defaultMessage: 'Negotiating with the catalog gods',
  },
  sentenceRefining2: {
    id: 'shopping_assistant_loading_message_refining_2',
    defaultMessage: 'Overthinking this (in a good way)',
  },
  sentenceRefining3: {
    id: 'shopping_assistant_loading_message_refining_3',
    defaultMessage: 'Unleashing my shopping superpowers',
  },
  sentenceRefining4: {
    id: 'shopping_assistant_loading_message_refining_4',
    defaultMessage: 'Going full detective mode',
  },
  sentenceRefining5: {
    id: 'shopping_assistant_loading_message_refining_5',
    defaultMessage: 'Entering flow state',
  },
} as const
